function useStylesheet() {
    const setPropertyCss = (key, value) => {
        window.document.documentElement.style.setProperty(key, value);
    };

    const getPropertyCss = (key) => {
        return window.document.documentElement.style.getPropertyValue(key);
    };

    return { setPropertyCss, getPropertyCss };
}

export default useStylesheet;



// WEBPACK FOOTER //
// ./src/core/helpers/useStylesheet.js